import * as React from "react"
import { Spinner } from "../spinner"
import * as styles from "./style.css"

export type LoadingProps = {
  message?: string
  className?: string
}

export function Loading({
  message = `Loading ...`,
  className = ``,
}: LoadingProps) {
  return (
    <div className={`${styles.root} ${className}`}>
      <Spinner className={styles.spinner} /> {message}
    </div>
  )
}
